import {NEW_ID} from '../../../common/constants/index.js'
import {locationSelector} from '../../../redux/selectors/ui/location.js'
import {
  RETURN_ORDER_CODES,
  SETTINGS,
} from '../../../common/constants/SettingsPanels.js'

export function currentReturnOrderCodeIDSelector(state) {
  const {pathComponents} = locationSelector(state)

  if (
    pathComponents[0] === SETTINGS &&
    pathComponents[1] === RETURN_ORDER_CODES &&
    pathComponents[2] &&
    pathComponents[2] !== NEW_ID
  ) {
    return Number(pathComponents[2]) || null
  }

  return null
}

export function isNewReturnOrderCodeSelector(state) {
  const {pathComponents} = locationSelector(state)

  return (
    pathComponents[0] === SETTINGS &&
    pathComponents[1] === RETURN_ORDER_CODES &&
    pathComponents[2] === NEW_ID
  )
}
